var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3872_4882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5921 8.70468C6.89442 9.10926 7.28013 9.44402 7.72306 9.68626C8.16599 9.9285 8.65579 10.0726 9.15923 10.1086C9.66267 10.1447 10.168 10.072 10.6409 9.89544C11.1138 9.71886 11.5432 9.44254 11.9 9.08521L14.0119 6.97117C14.6531 6.30664 15.0079 5.41662 14.9999 4.49279C14.9918 3.56897 14.6217 2.68525 13.9691 2.03198C13.3165 1.37871 12.4336 1.00816 11.5107 1.00013C10.5878 0.992105 9.69872 1.34725 9.03487 1.98906L7.82404 3.19407M9.4079 7.29531C9.10558 6.89074 8.71987 6.55597 8.27694 6.31373C7.83401 6.0715 7.34421 5.92744 6.84077 5.89135C6.33733 5.85526 5.83203 5.92797 5.35913 6.10456C4.88623 6.28114 4.4568 6.55746 4.09997 6.91479L1.98806 9.02883C1.34689 9.69336 0.992113 10.5834 1.00013 11.5072C1.00815 12.431 1.37833 13.3147 2.03094 13.968C2.68355 14.6213 3.56637 14.9918 4.48926 14.9999C5.41216 15.0079 6.30128 14.6528 6.96513 14.0109L8.16892 12.8059",
    stroke: "#105E96",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3872_4882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon-link.c1a06e2217c396fd981c6967b7063379.svg";
export { ForwardRef as ReactComponent };